import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map, catchError, tap, retry } from 'rxjs/operators';
import * as _ from 'lodash';
import * as io from 'socket.io-client';
import { EfoEgiService } from './egi.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EfoYellowPagesService {
  //private url = 'http://socket1.carbrewer.com:3002';
  private elevationUrl = environment.nestElevationApiUrl;

  private socketUrl = 'http://socket.epiphanex.com:5000';
  private socket;

  egiAccountInformation: any = [];

  constructor(
    private efoEgi: EfoEgiService,
    private http: HttpClient, // private errorHandlerService: ErrorHandlerService
  ) {}

  private endpoint = 'https://hubspot-api.epiphanex.com';

  zipLocations: any = [];
  getZipLocations(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.zipLocations)) {
      return of(this.zipLocations).pipe();
    } else {
      return this.efoEgi.getData('/yellowpages/getZipLocations', {}).pipe(
        map((rs) => {
          this.zipLocations = rs;
          return rs;
        }),
      );
    }
  }
  zipCodeReport: any = [];
  getZipCodeReport(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.getZipCodeReport)) {
      return of(this.getZipCodeReport).pipe();
    } else {
      return this.http
        .get<any>(
          `${environment.nestElevationApiUrl}/yellowpages/getZipCodeReport`,
        )
        .pipe(
          map((rs) => {
            this.getZipCodeReport = rs;
            return rs;
          }),
        );
    }
  }
  zipPopulations: any = [];
  getZipPopulations(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.zipPopulations)) {
      return of(this.zipPopulations).pipe();
    } else {
      return this.efoEgi.getData('/yellowpages/getZipPopulations', {}).pipe(
        map((rs) => {
          this.zipPopulations = rs;
          return rs;
        }),
      );
    }
  }
  zipGeo: any = [];
  getZipGeo(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.zipGeo)) {
      return of(this.zipGeo).pipe();
    } else {
      return this.efoEgi.getData('/yellowpages/getZipGeo', {}).pipe(
        map((rs) => {
          this.zipGeo = rs;
          return rs;
        }),
      );
    }
  }
  zipSummaryInformation: any = [];
  getZipSummaryInformation(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.zipSummaryInformation)) {
      return of(this.zipSummaryInformation).pipe();
    } else {
      return this.efoEgi
        .getData('/yellowpages/getZipSummaryInformation', {})
        .pipe(
          map((rs) => {
            this.zipSummaryInformation = rs;
            return rs;
          }),
        );
    }
  }
  getYpCountByZip(zips: any[]): Observable<any> {
    return this.getZipSummaryInformation().pipe(
      map((rs) => {
        var cntByZip = _.reduce(
          rs,
          (o, d) => {
            o[d.zip] = d.total_records;
            return o;
          },
          {},
        );
        return _.sum(_.map(zips, (z) => cntByZip[z]));
      }),
    );
  }
  queueYellowPagesZips(zips): Observable<any> {
    return this.efoEgi.getData('/yellowpages/queueYellowPagesZips', {
      zips: zips,
    });
  }
  queueZipProcessing(zips): Observable<any> {
    return this.efoEgi.getData('/yellowpages/queueZipProcessing', {
      zips: zips,
    });
  }
  fillInPostalLocations(zips): Observable<any> {
    return this.efoEgi.getData('/yellowpages/fillInPostalLocations', {
      zips: zips,
    });
  }
  batchEfoExportZips(zips): Observable<any> {
    return this.efoEgi.getData('/sdb/batchEfoExport', {
      account_num: 'R84276456',
      zips: zips,
    });
  }

  exportYpByZip(zips): Observable<any> {
    return this.efoEgi.getData('/yellowpages/exportYpByZip', { zips: zips });
  }

  loadYellowPagesEstimateNearZip(zip, distance): Observable<any> {
    return this.efoEgi.getData('/yellowpages/loadYellowPagesEstimateNearZip', {
      zip: zip,
      distance: distance,
    });
  }

  //--Older Yp Stuff

  getAudienceZips(state): Observable<any> {
    return this.http.post(`${this.elevationUrl}/yellowpages/getAudienceZips`, {
      state,
    });
  }

  getAudienceZipsSummary(options): Observable<any> {
    return this.http.post(
      `${this.elevationUrl}/yellowpages/getAudienceZipsSummary`,
      options,
    );
  }
  getStatePopulation(state): Observable<any> {
    return this.efoEgi.getData('/yp/getStatePopulation', { state: state });
  }
  getDealersFromApisState(state, options): Observable<any> {
    return this.efoEgi.getData(
      '/yp/getDealersFromApisState',
      _.extend({ state: state, granularity: 0.5 }, options),
    );
  }
  getDealersFromApis(options): Observable<any> {
    return this.efoEgi.getData('/yp/getDealersFromApis', options);
  }
  loadDealers2DbState(state, options): Observable<any> {
    return this.efoEgi.getData(
      '/yp/loadDealers2Db',
      _.extend({ states: [state], granularity: 0.5 }, options),
    );
  }
  loadDealers2DbZip(zip, options): Observable<any> {
    return this.efoEgi.getData(
      '/yp/loadDealers2DbByZip',
      _.extend({ zip: zip }, options),
    );
  }
  loadDealers2DbLargestCities(options): Observable<any> {
    return this.efoEgi.getData('/yp/loadDealers2DbByLargestCities', options);
  }
  cleanAllDealers(): Observable<any> {
    return this.efoEgi.getData('/yp/cleanAllDealers', {});
  }

  getStateData(): Observable<any> {
    return this.http.get(`${this.elevationUrl}/yellowpages/getStateData`);
  }
  // getZipData(options): Observable<any> {
  //   return this.efoEgi.getData('/elevation/yellowpages/getZipData', options);
  // }
  getZipData(options): Observable<any> {
    const { zip } = options;
    return this.http.post(
      `${this.elevationUrl}/yellowpages/getZipData`,
      options,
    );
  }
  // getZipData(options): Observable<any> {
  //   const { zip } = options;
  //   const params = new URLSearchParams(options);
  //   return this.http.get(
  //     `${this.elevationUrl}/yellowpages/getZipData?${params}`,
  //   );
  // }
  getDealerContactCounts(): Promise<any> {
    return this.http
      .get(`${this.elevationUrl}/cbr/dealerContactCounts`)
      .toPromise();
  }

  lookupYellowPages(options): Observable<any> {
    return this.efoEgi.getData('/yp/lookupYellowPages', options);
  }
  getYellowPages(url): Observable<any> {
    return this.efoEgi.getData('/yellowpages/getYellowPages', {
      url: url,
      selector: 'body',
    });
  }
  getYellowPagesOldPhantom(url): Observable<any> {
    return this.efoEgi.getData('/yellowpages/getYellowPagesOldPhantom', {
      url: url,
      selector: 'body',
    });
  }
  getYellowPagesEstimate(options): Observable<any> {
    return this.efoEgi.getData('/yp/getYellowPagesEstimate', options);
  }
  getGoogleDealers(options: {}): Observable<any> {
    return this.efoEgi.getData('/yp/getGoogleDealers', options);
  }
  getYpSummaryByZip(options: {}): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/yellowpages/getYpSummaryByZip`,
      options,
    );
  }
  getYpSummaryByState(): Observable<any> {
    return this.efoEgi.getData('/yp/getYpSummaryByState', {});
  }
  getCrissCrossReport(sales_record: {}): Observable<any> {
    //sales record with address
    return this.http.post(
      `${this.elevationUrl}/yellowpages/getCrissCrossReport`,
      sales_record,
    );
  }
  getEfoAudienceCounts(zips): Observable<any> {
    return this.efoEgi.getData('/yellowpages/getEfoAudienceCounts', {
      zips: zips,
    });
  }
  getEfoAudienceCountTotals(zips): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/yellowpages/getEfoAudienceCountTotals`,
      {
        zips: zips,
      },
    );
  }
  getHtml(url, selector): Observable<any> {
    return this.efoEgi.getData('/yellowpages/getHtml', {
      url: url,
      selector: selector,
    });
  }
  getHtmlCf(url, selector): Observable<any> {
    return this.efoEgi.getData('/yellowpages/getHtmlCf', {
      url: url,
      selector: selector,
    });
  }
  getHtmlPhantom(url, selector): Observable<any> {
    return this.efoEgi.getData('/yellowpages/getHtmlPhantom', {
      url: url,
      selector: selector,
    });
  }

  public socketListen = () => {
    if (_.isUndefined(this.socket)) {
      this.socket = io(this.socketUrl, {
        transports: ['websocket'],
      });
      this.socket.on('connect', () => {
        this.socket.emit(
          'new-message',
          'portal service connected: yellowpages.service',
        );
      });
    }
    return new Observable((observer) => {
      this.socket.on('yellowpages', (data) => {
        observer.next(data);
      });
    });
  };
}
